// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avneue-no-vendor -> repli-sandbox-avneue-no-vendor -> the-pointe-on-westshore-6fb7
// Generated: 2026-10-05T18:31:19.976Z
// Counts: 1 design, 14 content, 18 slot group, 0 collection binding, 3 section, 0 style

export const designOverrides = {
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#0095ff",
    "mappedField": null
  }
};

export const contentOverrides = {
  "apartment-sync.javascript_id": {
    "overrideType": "VALUE",
    "customValue": "asdfasdfasdf",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "110 Royyyyy",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitycardgrid.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>From poolside afternoons to state-of-the-art workouts, every detail at The Pointe on Westshore is designed to elevate the way you live. Explore the amenities that make coming home the best part of your day.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Thoughtfully finished, comfortably yours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside and you'll notice the difference in every finish, from sleek quartz countertops and stainless steel appliances to warm wood-style plank flooring underfoot. Generous walk-in closets, an in-home washer and dryer, and a private patio or balcony make everyday life feel effortless. It's a space that's been considered down to the last detail, so it's ready to become yours.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Details That Feel Like Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Resort-style living in Westshore, Tampa</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>From sunny afternoons by the Junior Olympic pool to easy evenings grilling on the sundeck, our shared spaces are built for the way you actually want to spend your time. Meet neighbors in the clubhouse lounge, let your pup off-leash in the bark park, or stay on track at the fitness park. It's a gated community designed to feel less like an address and more like a lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Room to Live Well</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Step inside our one, two, and three-bedroom homes, ranging from 687 to nearly 1,470 square feet of thoughtfully designed living space. Each residence features sleek quartz countertops, stainless steel appliances, subway tile backsplashes, and wood-style plank flooring. Generous walk-in closets, in-home washers and dryers, and private patios or balconies complete the elevated everyday experience.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at The Pointe on Westshore extends well beyond your front door. Cool off in the junior Olympic-size resort pool, break a sweat in the state-of-the-art fitness center, or gather with neighbors in the clubhouse lounge, coffee bar, and shuffleboard areas. With a gated entry, leash-free bark park, and shaded poolside grilling spaces, our Tampa community is built for both relaxation and connection.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.learn_more": {
    "overrideType": "VALUE",
    "customValue": "<p>The Pointe on Westshore offers spacious one, two, and three-bedroom apartments finished with stainless steel appliances, quartz countertops, and wood-style plank flooring. Residents enjoy a gated community with a Junior Olympic-size pool, a state-of-the-art fitness center, a leash-free bark park, and welcoming lounge spaces. Set in the heart of Tampa's Westshore District, you're minutes from International Plaza, top dining, Tampa International Airport, and the waterfront. Schedule a tour today to find your perfect fit.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.romance_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Come home to sunlit spaces, resort-style comfort, and the easy rhythm of Tampa's Westshore District. Here, quartz-topped kitchens, spacious walk-in closets, and a shimmering Junior Olympic pool are simply part of everyday life. This is where modern living meets the warmth of a true Florida community.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Pointe on Westshore, your four-legged family members are just as welcome as you are. From our leash-free bark park to our on-site pet spa, we've created a community where dogs and cats can play, relax, and feel right at home under the sunny Tampa skies.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitycardgrid.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-3008-7702-937a-0c19127d644f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and outdoor seating."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Junior Olympic Size Pool"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Cool off in our Junior Olympic-size pool, framed by lush landscaping and lounge chairs made for sunny Tampa afternoons. It's your own resort-style escape, just steps from home."
      }
    }
  },
  "amenitycardgrid.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-70df-707b-8156-a19953c6a7cf.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with weights, cardio machines, and benches."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Fitness Center"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Keep your routine on track in our state-of-the-art fitness center, stocked with cardio machines, free weights, and strength equipment. Everything you need for a great workout, without ever leaving the community."
      }
    }
  },
  "amenitycardgrid.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-677a-72d9-a799-ff9f1c111e05.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stylish lounge area with a sectional sofa, accent chairs, and three TVs on a wood-slatted wall."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Clubhouse"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Gather with neighbors or unwind on your own in our stylish clubhouse, complete with comfortable seating and big-screen entertainment. It's the perfect spot to relax, connect, and feel at home."
      }
    }
  },
  "amenitycardgrid.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-4d1d-71d3-ad44-b50ab908b081.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment and seating."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Leash-Free Bark Park & Pet Spa**"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Let your best friend run free at our leash-free bark park, featuring agility equipment and shaded seating for owners. Because here, every member of the family gets to enjoy the good life."
      }
    }
  },
  "amenitycardgrid.card_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-55f5-7733-87e5-579b88a7c1e3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor lounge area with blue seating and tables, Westshore Club building signage in background."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Community Lounge Areas"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Step outside to our stylish community lounge areas, where comfortable seating and fresh Florida air set the scene for morning coffee or evening conversation. It's outdoor living made effortless."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-5499-71db-b131-190871a6d18e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A modern living room with a gray sofa, accent chairs, and a black and white striped rug."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-3f66-74e9-90d1-0e51f9dd6f25.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment building exterior with white and blue siding and parked cars."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-8d73-72ef-95b8-91ab55abf7a6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a modern apartment complex under construction with buildings facing a body of water and a bridge in the distance."
      }
    }
  },
  "ctasection.card4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-5fb1-71b8-8f5c-0ebe0c0c4e03.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with exercise equipment including stationary bikes, yoga mats, resistance bands, and medicine balls."
      }
    }
  },
  "gallery.hero_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-2313-74ce-8045-6a44d1b43db7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with island, stainless steel appliances, and open-concept living area."
      }
    }
  },
  "gallery.hero_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-677a-72d9-a799-ff9f1c111e05.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Stylish lounge area with a sectional sofa, accent chairs, and three TVs on a wood-slatted wall."
      }
    }
  },
  "gallery.hero_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-7e67-761a-831e-cee756361e8d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Luxury apartment complex with a resort-style pool and lounge chairs."
      }
    }
  },
  "petpolicy.feature_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-4d1d-71d3-ad44-b50ab908b081.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with agility equipment and seating."
      }
    }
  },
  "petpolicy.lifestyle_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-55f5-7733-87e5-579b88a7c1e3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor lounge area with blue seating and tables, Westshore Club building signage in background."
      }
    }
  },
  "propertyoverview.feature_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-7e67-761a-831e-cee756361e8d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Luxury apartment complex with a resort-style pool and lounge chairs."
      }
    }
  },
  "propertyoverview.feature_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-230f-727a-8742-c9b513ad5225.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern living room and kitchen with contemporary artwork and comfortable seating."
      }
    }
  },
  "propertyoverview.feature_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-5bc3-70bd-9d93-3636d3319a48.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A well-lit bedroom featuring a king-size bed with white linens, decorative pillows, and a throw blanket. Artwork adorns the wall above the headboard. A ceiling fan circulates air, and a closet is visible to the left."
      }
    }
  },
  "propertyoverview.feature_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162940/019cfddf-5ac6-7725-90da-53b58f6ab3d2.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern community lounge with two shuffleboard tables, bar area, and seating."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 3
    }
  ]
};

export const styleOverrides = {};
